export default [
  [
    `Рост`,
    `98-104`,
    `106-116`,
    `118-128`,
    `130-140`,
    `142-154`,
    `154-164`
  ],
  [
    `Возраст`,
    `3-4`,
    `5-6`,
    `7-8`,
    `9-10`,
    `11-12`,
    `13-14`
  ]
];
